export default __webpack_public_path__ + "img/homepage.product.06.asset.28781d84.jpg";